import { Stack, Typography } from '@mui/material';
import { VySwitch } from '../../../../components/new-design/inputs/VySwitchNew';
import type { MeterInput, NewMeter } from '@vy/types';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { CreateProductPageConditions } from './CreateProductPageConditions/CreateProductPageConditions';
import { CreateProductPageSummary } from './CreateProductPageSummary';
import { EventNameSelect } from './EventNameSelect';
import { SectionContainer } from './SectionContainer';
import { SectionContainerItem } from './SectionContainerItem';

export const CreateProductPageForm: React.FC = () => {
  const { control } = useFormContext<MeterInput, unknown, NewMeter>();

  return (
    <Stack
      sx={{
        rowGap: 3,
        position: 'relative',

        '::before': {
          content: '""',
          position: 'absolute',
          left: 'calc(50% - 0.5px)',
          display: 'block',
          width: '1px',
          backgroundColor: 'rgba(0, 0, 0, 0.12)',
          height: '100%',
          zIndex: 0,
        },

        '> *': {
          position: 'relative',
          zIndex: 1,
        }
      }}>
      <Controller
        control={control}
        name="isTaxable"
        defaultValue={true}
        render={({ field }) => (
          <VySwitch
            checked={field.value ?? true}
            onChange={(_, checked) => field.onChange(checked)}
            label="Tax on this product"
          />
        )}
      />
      <SectionContainer title="Events">
        <SectionContainerItem>
          <Typography variant="subtitle1">When this event name is</Typography>

          <Controller
            control={control}
            name="eventName"
            render={({ field }) => (
              <EventNameSelect
                value={field.value}
                onChange={(event, newValue) => {
                  event.preventDefault();
                  field.onChange(newValue);
                }}
                inputRef={field.ref}
              />
            )}
          />
        </SectionContainerItem>
      </SectionContainer>
      <CreateProductPageConditions />
      <CreateProductPageSummary />
    </Stack>
  );
};
